import { trackUsages } from '../graphql/mutations';

export const PeriodicFlushQueue = {
    _queue: [],
    _intervalId: null,
    _INTERVAL_MS: 2000,
    _MAX_BATCH: 200,
    _API: null,
    useAPI: API => {
        PeriodicFlushQueue._API = API;
    },
    start: () => {
        if ( PeriodicFlushQueue._intervalId ) clearInterval( PeriodicFlushQueue._intervalId );
        PeriodicFlushQueue._intervalId = setInterval( PeriodicFlushQueue._flush, PeriodicFlushQueue._INTERVAL_MS );
    },
    stop: () => {
        if ( PeriodicFlushQueue._intervalId ) clearInterval( PeriodicFlushQueue._intervalId );
        PeriodicFlushQueue._intervalId = null;
    },
    flushNow: () => {
        PeriodicFlushQueue._flush()
    },
    add: event => {
        PeriodicFlushQueue._queue.push( event );
    },
    _flush: () => {
        if ( PeriodicFlushQueue._queue.length === 0 ) return;
        const toSend = PeriodicFlushQueue._queue.splice(0, PeriodicFlushQueue._queue.length );

        console.log(
            `[Tracker] FLUSH ${toSend.length} event(s) @ ${new Date().toISOString()}`
        );

        try {
            PeriodicFlushQueue._API.graphql({
                query: trackUsages,
                variables: { events: toSend },
            }).then( response => {
                console.log( 'response' , response );
            } ).catch( error => {
                console.error( 'Tracking error' , error );
            } );
            console.table(
                toSend.map( ( { timestamp, event, screen, sessionId, userId, accountId, props } ) => ( {
                    timestamp, event, screen, sessionId, userId, accountId,
                    props: props ? JSON.stringify( props ) : ''
                } ) )
            );
        } catch {
            console.log( toSend );
        }
    }
}
